import {
    IsSoldPollNoAction,
    IsSoldPollShowAction,
    IsSoldPollYesAction,
    IS_SOLD_POLL_NO,
    IS_SOLD_POLL_SHOW,
    IS_SOLD_POLL_YES,
} from 'mk2/apps/bazaar/containers/IsSoldPoll/IsSoldPoll.actions';
import { Reducer } from 'redux';

export interface State {
    show: boolean;
    productId: number;
}

export const initialState: State = {
    show: false,
    productId: null,
};

type Actions = IsSoldPollShowAction | IsSoldPollYesAction | IsSoldPollNoAction;

const reducer: Reducer<State> = (state: State = initialState, action: Actions) => {
    switch (action.type) {
        case IS_SOLD_POLL_SHOW:
            return {
                ...state,
                show: true,
                productId: action.productId,
            };
        case IS_SOLD_POLL_YES:
        case IS_SOLD_POLL_NO:
            // Close modal
            return {
                ...state,
                show: false,
                productId: null,
            };
        default:
            return state;
    }
};

export default reducer;
